import * as React from "react";

function SvgPageRight(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1.5 1l7 7-7 7" stroke="#fff" strokeWidth={2} />
    </svg>
  );
}

export default SvgPageRight;
